import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormError, FormLayout, Panel} from 'shared/components';
import {EmployeeSelector} from 'main/components';

const Employees = observer(({uiState}) => {
  const {schedule, errors} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.schedules.edit.steps.Employees')}
        description={t('time_tracking.manage.schedules.edit.Select the employees that will be included in this schedule.')}
      />
      <FormLayout>
        <EmployeeSelector
          selectors={['location', 'department', 'manager', 'employee']}
          selectedEmployees={schedule.employees}
          onChange={employees => schedule.setEmployees(employees)}
        />
        <FormError message={errors.employees}/>
      </FormLayout>
    </div>
  );
});

export default Employees;
